__turbopack_context__.v({
  "box": "w0-5vW_box",
  "box--active": "w0-5vW_box--active",
  "box--error": "w0-5vW_box--error",
  "box--m": "w0-5vW_box--m",
  "box--s": "w0-5vW_box--s",
  "boxWrap": "w0-5vW_boxWrap",
  "control": "w0-5vW_control",
  "control--disabled": "w0-5vW_control--disabled",
  "glyph": "w0-5vW_glyph",
  "input": "w0-5vW_input",
  "inverse": "w0-5vW_inverse",
  "label": "w0-5vW_label",
  "root": "w0-5vW_root",
});
